import ClientCSharpApplication from "../../pages/client/csharp/ClientCSharpApplication"
import ClientCSharpAssemblyReference from "../../pages/client/csharp/ClientCSharpAssemblyReference"
import ClientCSharpDocker from "../../pages/client/csharp/ClientCSharpDocker"
import ClientCSharpPackageReference from "../../pages/client/csharp/ClientCSharpPackageReference"
import { getNonLocalLicenses } from "../../pages/client/shared/licenses"
import InstallEngine from "../../pages/InstallEngine"
import InstallLicenseTools from "../../pages/InstallLicenseTools"
import RetrieveLocalLicense from "../../pages/RetrieveLocalLicense"
import { createDescriptor, PageDescriptor } from "../../pages/types"
import { ApplicationBrick, ApplicationLicense } from "./ApplicationBrick"

export class CSharpApplicationBrick extends ApplicationBrick {
    constructor(license: ApplicationLicense, readonly os: string, framework: string, packageManager: string, isContainer: boolean, isOrchestrated: boolean) {
        super(license, 'cs', framework, packageManager, isContainer, isOrchestrated)
    }

    public key(): string { 
        return 'app-csharp'
    }

    *getPages(): Generator<PageDescriptor> {
        const { os, license, packageManager } = this
        const isContainer = this.isContainer()
        if(this.requireLicenseTools()) {
            yield createDescriptor(InstallLicenseTools, { os })
        }
        if(this.requiresFullInstallation()) {
            yield createDescriptor(InstallEngine, { os, installPython: packageManager=='' })
        }        
        if(this.isLocalLicense()) {
            yield createDescriptor(RetrieveLocalLicense, {})
        } else {
            yield *getNonLocalLicenses(license, this.isContainer(), os)
        }
        switch(this.packageManager)
        {
            case 'nuget':
                yield createDescriptor(ClientCSharpPackageReference, { os })
                break
            default:
                yield createDescriptor(ClientCSharpAssemblyReference, { os, isContainer })
                break
        }        
        if(license !== null) {
            yield createDescriptor(ClientCSharpApplication, { license, needsLicenseFile: this.requireLicenseFile() })
        }
        if(this.isContainer()) {
            yield createDescriptor(ClientCSharpDocker, { packageManager, requiresFullInstallation: this.frameworkRequiresFullInstallation() })
        }
        // TODO Visual Studio project file
    }
}